import { Service } from "./service"

export const ProductsListingService = Service


// WEBPACK FOOTER //
// ./src/state/listing/product/service/index.ts